import { log, parPage } from "../../config";
import { getQueryStringFrmObject, getApi } from "../helpers/utility";
class LogApi {
 
  readLogs= async (readFilter,page) => {
    console.log('page', page)
    let finalListEndPoint;
    finalListEndPoint = log.logsList + "?per_page=" + parPage+"&pageNo="+page;
    let searchParams = { info: readFilter };
    if (searchParams.info!=="") {
      var queryString = getQueryStringFrmObject(searchParams);
      finalListEndPoint = finalListEndPoint +"&" + queryString;
    }
    var result = await getApi(finalListEndPoint);
    return result;
  };
}
export default new LogApi();
